/**
 * This file is the webpack bundler entry point.
 *
 * All scripts required by our application are pulled in
 * as dependencies where they are used.
 */
import '@babel/polyfill';
import App from './app';

if (App.checkLocalStorageHack()) {
  document.body.innerHTML = '';

  let error = document.createElement('div');
  error.innerHTML = '<div class="error" style="margin-top: 20vh;"><h1 style="text-align: center;"><i class="fa fa-ban"></i></h1><h2 style="text-align: center;">Session Expired. Please contact your system administrator.</h2><p style="text-align: center;">If the problem persists, please contact <a href="mailto:telematics@ur.com">telematics@ur.com</a></p></div>';
  
  document.body.appendChild(error);
} else {
  (async () => await App.init())();
}
